// Proppe — Home page
// Renders the landing page into the given container.
// Week 1: foundation/placeholder. Week 2 onwards: real hero + search.

import { CONSTANTS } from '../config/constants.js';
import { toast, esc } from '../modules/ui.js';

export function renderHome(container) {
  const year = new Date().getFullYear();

  container.innerHTML = `
    <header class="home-header">
      <div class="container home-header-inner">
        <a href="/" class="brand">Proppe</a>
        <nav class="nav">
          <a href="${esc(CONSTANTS.LIVE_SITE_URL)}" class="nav-link" target="_blank" rel="noopener">Live Site ↗</a>
          <button class="btn btn-primary" id="cta-btn">Notify Me</button>
        </nav>
      </div>
    </header>

    <main class="hero">
      <div class="container hero-inner">
        <span class="badge">v${esc(CONSTANTS.VERSION)} · Foundation deployed ✓</span>
        <h1 class="hero-title">
          Real estate,<br/>
          <span class="hero-title-accent">reimagined for India.</span>
        </h1>
        <p class="hero-subtitle">
          The next-generation Proppe platform. Faster, smarter, built modular —
          launching in stages.
        </p>
        <div class="hero-actions">
          <button class="btn btn-primary" id="notify-btn">Notify Me When Live</button>
          <a href="${esc(CONSTANTS.LIVE_SITE_URL)}" class="btn btn-secondary" target="_blank" rel="noopener">
            Visit Current Site →
          </a>
        </div>
      </div>
    </main>

    <section class="status">
      <div class="container">
        <h2 class="status-heading">Build Progress</h2>
        <div class="status-grid">
          <div class="status-card done">
            <div class="status-num">PHASE 01</div>
            <div class="status-label">Foundation</div>
            <div class="status-state">✓ Deployed</div>
          </div>
          <div class="status-card todo">
            <div class="status-num">PHASE 02</div>
            <div class="status-label">Core Modules</div>
            <div class="status-state">In progress</div>
          </div>
          <div class="status-card todo">
            <div class="status-num">PHASE 03</div>
            <div class="status-label">Features</div>
            <div class="status-state">Coming soon</div>
          </div>
          <div class="status-card todo">
            <div class="status-num">PHASE 04</div>
            <div class="status-label">Launch</div>
            <div class="status-state">Coming soon</div>
          </div>
        </div>
      </div>
    </section>

    <footer class="footer">
      <div class="container">
        <p>© ${year} Proppe · Building day by day · Made in India 🇮🇳</p>
      </div>
    </footer>
  `;

  // Wire up buttons
  const handleNotify = () => {
    toast('Foundation deployed successfully — full launch coming soon!', 'success');
  };

  const ctaBtn = container.querySelector('#cta-btn');
  const notifyBtn = container.querySelector('#notify-btn');
  if (ctaBtn) ctaBtn.addEventListener('click', handleNotify);
  if (notifyBtn) notifyBtn.addEventListener('click', handleNotify);
}
